import styled from 'styled-components'

import { Colors } from 'common-constants/colors'
import { media } from 'components/presentational'

export const StyledWrapperField = styled.div`
  display: inline-block;
  max-width: 100%;

  ${media.tabletLarge`
    display: block;
  `}
`

export const StyledDeclineGreeting = styled.span`
  color: ${Colors.warning};

  ${media.tabletLarge`
    display: block;
  `}
`
